import * as Sentry from "@sentry/react";

export const sentryDSN = process.env.REACT_APP_SENTRY_DSN || "https://cf84ec2a28db9ee3a2b3a748d7348265@o4507622289047552.ingest.de.sentry.io/4507781958926416"
export const sentryENV = process.env.REACT_APP_SENTRY_ENV || 'production'

Sentry.init({
  dsn: sentryDSN,
  environment: sentryENV,
  tunnel: "https://stela.sz.cz/api/tunnel/",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        useCompression: true,
        }),
    Sentry.captureConsoleIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/stela\.sz\.cz\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});